import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-172" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-173" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-174" data-mp="3fyvxs9ef7bak">
          <span aria-hidden="true" data-id="element-175" data-mp="3b01gxd00jwt3">💬 </span>Ce que disent les profs
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-176" data-mp="3700q0svq9t55">
          <span aria-hidden="true" data-id="element-177" data-mp="32063f1izjppw">⭐️⭐️⭐️⭐️⭐️</span> 4,9/5 · +2 000 profs
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 md:grid-cols-3" data-id="element-178" data-mp="2x0tg6fo7cgms">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-179" data-mp="2s28cg69qretl">
              <div className="text-sm text-amber-500" aria-label="5 étoiles sur 5" data-id="element-180" data-mp="v8wtc9wl3kcp">
                <span aria-hidden="true" data-id="element-181" data-mp="q8iw7mwitutg">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-182" data-mp="h4n2y9bp5v9v">
                &laquo;&nbsp;{item.quote}&nbsp;&raquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-183" data-mp="79bmnmkn4g00">
                <p className="text-xs font-bold text-ink" data-id="element-184" data-mp="c6v9vbzbg343">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-185" data-mp="c8y1g0g4a4ax">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-186" data-mp="14w28eayrsspc">
          Témoignages illustratifs.
        </p>
      </div>
    </section>;
}